import { toast } from 'react-toastify';
import apiClient from "../network/apiClient";

class CheckoutApiProvider {
  async checkout(input) {
    try {
      // Transform input to match mobile API 'orders' payload
      const mobilePayload = {
        placedBy: input.userId, // Use the passed User ID
        placedByModel: input.isGuest ? 'Guest' : 'User', // Dynamic model
        items: (input.items || input.courseId || []).map(item => ({
          productId: item.productId || item.id || item._id, // Ensure we have product ID
          quantity: item.quantity || 1,
          unitPrice: item.offerPrice || item.price || 0,
          attributes: item.attributes || {},
          // offerId? if exists
        })),
        shippingAddress: {
          contactName: input.firstName,
          street: input.address1,
          city: input.city || "",
          state: input.state || "",
          postalCode: input.zipCode,
          country: input.country,
          contactNumber: input.phoneNo,
          email: input.email
        },
        totalAmount: Number(input.amount),
        paymentMode: input.paymentMethod || 'Cash',
        currency: input.currency || 'INR',
        // paymentDetails?
      };

      const response = await apiClient.post("orders", mobilePayload);
      const message = response.data?.message ?? "Order created successfully";

      if ((response.status == 200 || response.status == 201) && response) {
        toast.success("Order Created Successfully");
        return {
          status: response.status,
          response: response.data
        };
      } else {
        toast.error(message);
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      console.error("Checkout Request Error:", error);
      const errorMessage = error?.response?.data?.message || "Checkout failed. Please try again.";
      toast.error(errorMessage);
      return {
        status: false,
        response: []
      };
    }
  }
  async paymentverify(input) {
    try {
      const response = await apiClient.post("cart-detail/nomodWebhook", input);
      if (response.status == 200 || response.status == 201 && response) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        response: []
      };
    }
  }

  async verifyCheck(input) {
    console.log(input, "iiiii");

    try {
      const response = await apiClient.post("cart-detail/verify-check", input);
      if (response.status == 200 || response.status == 201 && response) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      return {
        status: false,
        response: []
      };
    }
  }
}
const apiCheckout = new CheckoutApiProvider()
export default apiCheckout